import { ButtonProps, Button as ChakraButton } from '@web/components/chakra-ui/button'
import { forwardRef, Ref } from 'react'
import { ButtonTheme } from './styles'

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props: ButtonProps, ref: Ref<HTMLButtonElement>) => {
  const styles = ButtonTheme.variants[props.buttonAppearance as keyof typeof ButtonTheme.variants]
  return <ChakraButton ref={ref} variant={styles?.variant} css={styles} {...props} />
})

export default Button
